import { Component } from '@angular/core';
import { CommentRelationPlugin, RelationCommentService } from '@kaiser-software/chassis-comments';
import 'rxjs/add/operator/finally';

@Component({
    selector: 'eyewatch-observations-comment-plugin',
    templateUrl: './comments.plugin.html',
    styleUrls: ['./comments.plugin.scss'],
    providers: [RelationCommentService]
})
export class CommentsPlugin extends CommentRelationPlugin {
}



// WEBPACK FOOTER //
// ./apps/eyewatch/src/app/eyewatch/observations/plugins/comments/comments.plugin.ts